import { render, staticRenderFns } from "./TipoClienteForm.vue?vue&type=template&id=dcc92116&"
import script from "./TipoClienteForm.vue?vue&type=script&lang=js&"
export * from "./TipoClienteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports